// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App'
import router from './router'
import Vuefire from 'vuefire'
import firebase from './service/firebase'
import { store } from './store'
import alert from '@/components/alert'
import SocialSharing from 'vue-social-sharing'

Vue.use(Vuetify)
Vue.use(Vuefire)
Vue.use(SocialSharing)

Vue.config.productionTip = false

Vue.component('alert', alert)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  firebase: {
    Trust: firebase.database.ref('Trust').orderByChild('created_at')
  },
  router,
  store,
  template: '<App/>',
  components: { App },
  created: function () {
    console.log(this.$route.path)
    if (this.$route.path === '/') {
      if ((window.matchMedia('(display-mode: standalone)').matches)) {
        this.$router.push('/')
      } else if ((window.navigator.platform !== 'Win16') && (window.navigator.platform !== 'Win32') && (window.navigator.platform !== 'Win64')) {
        this.$router.push('/')
      } else {
        // console.log(window.navigator.platform)
        this.$router.push('/')
      }
    } else {
      this.$route.path
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js